export default {
    CHECK_OUT_PLACE_ORDER: '[CHECKOUT] CHECK_OUT_PLACE_ORDER',
    CHECK_OUT_PLACE_ORDER_RESULT: '[CHECKOUT] CHECK_OUT_PLACE_ORDER_RESULT',
    CHECK_OUT_PLACE_ORDER_ERROR: '[CHECKOUT] CHECK_OUT_PLACE_ORDER_ERROR',
    CHECKOUT_TO_SELECT_PAYMENTS: '[QUOTE] CHECKOUT_TO_SELECT_PAYMENTS',
    CHECKOUT_TO_CATALOG: '[QUOTE] CHECKOUT_TO_CATALOG',
    CHECKOUT_SWITCH_PAGE: '[CHECKOUT] CHECKOUT_SWITCH_PAGE',
    CHECKOUT_INIT_PAYMENTS: '[QUOTE] INIT_PAYMENTS',
    CHECKOUT_PROCESS_PAYMENT: '[CHECKOUT] CHECKOUT_PROCESS_PAYMENT',
    CHECKOUT_PROCESS_SINGLE_PAYMENT_RESULT: '[CHECKOUT] CHECKOUT_PROCESS_SINGLE_PAYMENT_RESULT',
    CHECKOUT_PROCESS_SINGLE_PAYMENT_ERROR: '[CHECKOUT] CHECKOUT_PROCESS_SINGLE_PAYMENT_ERROR',
    CHECKOUT_TO_APPLY_GIFT_CARD : '[QUOTE] CHECKOUT_TO_APPLY_GIFT_CARD',
}



// WEBPACK FOOTER //
// ./src/view/constant/CheckoutConstant.js